// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resize-container[data-v-5932ebca],\n.resize-iframe[data-v-5932ebca] {\n  width: 100%;\n  height: 100%;\n}\n.resize-container[data-v-5932ebca] {\n  position: relative;\n  height: 0;\n}\n.resize-iframe[data-v-5932ebca] {\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  top: 0;\n  min-height: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
